export class ValidationCV {

    public static all: ValidationCV = new ValidationCV();

    public EXISTS = 'exists';
    public NOT_EXISTS = 'notExists';
    public MIN = 'min';
    public MAX = 'max';

    constructor() {
    }
}
